import { styled } from 'linaria/react';
import { css } from 'linaria';

export const Wrapper = styled.div`
	margin-top: 24px;
`;

export const StyledTable = styled.table`
	width: 100%;
	border-collapse: collapse;
`;

export const StyledTr = styled.tr`
	border-bottom: 1px solid var(--control-minor);
`;

export const StyledTd = styled.td`
	vertical-align: top;
	padding-block: 24px;
`;

export const priceTd = css`
	text-align: end;
`;

export const StyledUl = styled.ul`
	padding-left: 0;
	margin: 2px 0 0;
	list-style: none;
`;

export const categoryNameStyles = css`
	margin-bottom: 8px;
`;

export const serviceDescriptionStyles = css`
	position: relative;
	padding-left: 8px;
	&:before {
		position: absolute;
		left: 0;
		display: block;
		content: '-';
	}
`;

export const titleStyles = css`
	margin-top: 40px;
	& + div[class^='Wrapper'] {
		margin-top: 24px;
	}
`;
